import React, { Component } from 'react'
import { Text } from '@cred/react-text'
import Link from 'components/link'
import Tooltip from 'components/tooltip'
import PropTypes from 'prop-types'
import { tooltipContent } from './tooltip-content'
import styles from './styles.scss'

const getContentSubject = (theme) => {
  const contentSubject = {
    fox: 'Fox Advertising Disclosure',
    thebalance1: 'The Balance Advertising Disclosure',
    investopedia1: 'Investopedia Advertising Disclosure',
  }

  return contentSubject[theme]
}

class AdvertiserDisclosure extends Component {
  static propTypes = {
    offSet: PropTypes.string,
    tooltipId: PropTypes.string,
    theme: PropTypes.string,
  }

  static defaultProps = {
    offSet: '{"left": -85}', // Extra offset to make sure tooltip is out of container
    tooltipId: 'disc-tooltip',
    theme: 'fox',
  }

  constructor(props) {
    super(props)

    this.state = {
      hide: true,
    }
  }

  componentDidMount() {
    this.setState({ hide: false })
  }

  render() {
    const { offSet, tooltipId, theme } = this.props,
      { hide } = this.state,
      content = tooltipContent[theme] || ''

    return (
      <div className={styles.container}>
        <Link className={`${styles.disclosureLink} ${styles[theme]}`} data-tip data-for={tooltipId} data-offset={offSet}>
          Advertising Disclosure
          { !hide
            && (
              <Tooltip id={tooltipId} place="bottom" className={styles.advertiserTooltip} analyticsOptions={{ contentSubject: getContentSubject(theme) }}>
                { this.renderTooltipContent(content) }
              </Tooltip>
            )}
        </Link>
      </div>
    )
  }

  renderTooltipContent = (content) => (<Text type="small-alt" className={styles.copy}>{content}</Text>)
}

export { AdvertiserDisclosure }
